export default "__VITE_ASSET__ClSd9bjD__"